import React from 'react'
import { Link } from 'react-router-dom'
import PWAInstallButton from '../PWAInstallButton'

export default function Hero3D() {
  return (
    <section className="hero-panel">
      <div>
        <span className="eyebrow">Math.Kids 3D • matemática, programação e games</span>
        <h1>Aprendizagem matemática adaptada para crianças com perfis diversos.</h1>
        <p>
          Plataforma com atendimento online, anamnese inicial, atividades mediadas com ABA,
          material dourado e trilhas personalizadas para ensino regular, programação e games.
        </p>
        <div className="hero-actions">
          <Link to="/atividades" className="btn btn-primary">Explorar trilhas</Link>
          <Link to="/profissionais" className="btn btn-secondary">Agendar atendimento</Link>
          <PWAInstallButton />
        </div>
      </div>
      <div className="hero-stats-grid">
        <div className="stat-block"><strong>3</strong><span>dimensões de aprendizagem</span></div>
        <div className="stat-block"><strong>ABA</strong><span>apoio por análise do comportamento</span></div>
        <div className="stat-block"><strong>Material dourado</strong><span>concreto + visual + digital</span></div>
        <div className="stat-block"><strong>Anamnese</strong><span>triagem antes do atendimento online</span></div>
      </div>
    </section>
  )
}
